import LocalizedStrings from "react-localization";
import {common_strings} from "../translations/common_translations";
import localeHelpers from "./LocaleHelper";
import yogaIconWhite from "assets/img/icons/common/yoga_icon_white.svg"
import gymIconWhite from "assets/img/icons/common/gym_icon_white.svg"
import ballIcon from "assets/img/icons/common/ball.png"
import danceIconWhite from "assets/img/icons/common/dance_icon_white.svg"
import maIconWhite from "assets/img/icons/common/ma_icon_white.svg"
import yogaPersonWhite from "assets/img/icons/common/yoga-person-white.svg"
import gymPersonWhite from "assets/img/icons/common/gym-person-white.svg"
import genericPersonWhite from "assets/img/icons/common/generic-person-white.svg"
import maPersonWhite from "assets/img/icons/common/ma-person-white.svg"

let commonStrings = new LocalizedStrings(common_strings);

const businessHelper = {

    business: function () {
        if (localStorage.getItem('business') === 'undefined') {
            localStorage.removeItem('business');
            localStorage.removeItem('cur_user');
            localStorage.removeItem('at');
        } else {
            return JSON.parse(localStorage.getItem('business'))
        }
    },

    subUser: function () {
        if ([undefined, 'undefined'].includes(localStorage.getItem('cur_user')))
            return null
        else
            return JSON.parse(localStorage.getItem('cur_user'))
    },

    at: function () {
        return localStorage.getItem('at')
    },

    currency: function () {
        const business = this.business();
        if (business && business.cur) {
            if (business.cur.includes("-")) {
                return business.cur.split('-')[1]
            } else {
                return business.cur
            }
        } else return "$"
    },

    currencyLabel: function () {
        const business = this.business();
        if (business.cur) {
            if (business.cur.includes("-")) {
                return business.cur.split('-')[0]
            } else {
                return business.cur
            }
        } else return "USD"
    },

    saveBusiness(business) {
        localStorage.setItem('business', JSON.stringify(business));
    },

    saveSubUser(subUser) {
        localStorage.setItem('cur_user', JSON.stringify(subUser));

        if (subUser && subUser.locale)
            localeHelpers.saveLocaleLocally(subUser.locale)
        else
            localeHelpers.saveLocaleLocally("en")
    },

    businessLocales() {
        try {
            if (localStorage.b_locales) {
                return JSON.parse(localStorage.b_locales)
            } else {
                return []
            }
        } catch (e) {
            return []
        }
    },

    saveUserSession(data) {
        if (data.auth_token) localStorage.setItem('at', data.auth_token);
        localStorage.setItem('business', JSON.stringify(data.user));
        localStorage.setItem('cur_user', JSON.stringify(data.current));
        localStorage.setItem('b_locales', JSON.stringify(data.locales));

        if (data.current && data.current.locale_id) {
            this.saveCurrentLocale(data.current.locale_id)
        } else {
            this.checkLocale(data)
        }

        window.dispatchEvent(new Event("user_updated", {}));

        if (data.current && data.current.locale)
            localeHelpers.saveLocaleLocally(data.current.locale)
        else
            localeHelpers.saveLocaleLocally("en")
    },

    backgroundImage: function (target) {
        const business = this.business();
        let type = "yoga";
        if (business && business.b_type) type = business.b_type;
        switch (target) {
            case "class_overview":
                switch (type) {
                    case "yoga":
                        return require("assets/img/theme/yoga-index.jpg");
                    case "gym":
                        return require("assets/img/theme/gym-index.jpg");
                    case "dance":
                        return require("assets/img/theme/dance-login.jpg");
                    case "school":
                        return require("assets/img/theme/yoga-index.jpg");
                    case "ma":
                        return require("assets/img/theme/ma-index.jpg");
                    case "team":
                        return require("assets/img/theme/team-index.jpg");
                    case "basketball":
                        return require("assets/img/theme/basketball.jpg");
                    default:
                        return require("assets/img/theme/yoga-index.jpg");
                }
            case "index":
                switch (type) {
                    case "team":
                        return require("assets/img/theme/team-index.jpg");
                    case "yoga":
                        return require("assets/img/theme/yoga-index-4.jpg");
                    case "gym":
                        return require("assets/img/theme/gym-index.jpg");
                    case "dance":
                        return require("assets/img/theme/dance-index.jpg");
                    case "school":
                        return require("assets/img/theme/yoga-index.jpg");
                    case "ma":
                        return require("assets/img/theme/ma-index.jpg");
                    case "basketball":
                        return require("assets/img/theme/basketball.jpg");
                    default:
                        return require("assets/img/theme/yoga-index.jpg");
                }
            case "clients":
                switch (type) {
                    case "yoga":
                        return require("assets/img/theme/yoga-index.jpg");
                    case "gym":
                        return require("assets/img/theme/gym-index.jpg");
                    case "team":
                        return require("assets/img/theme/team-index.jpg");
                    case "dance":
                        return require("assets/img/theme/dance-login.jpg");
                    case "school":
                        return require("assets/img/theme/yoga-index.jpg");
                    case "basketball":
                        return require("assets/img/theme/basketball.jpg");
                    case "ma":
                        return require("assets/img/theme/ma-index.jpg");
                    default:
                        return require("assets/img/theme/yoga-index.jpg");
                }
            default:
                break;
        }
    },

    classIcon: function () {
        const business = this.business();
        let type = "yoga";
        if (business && business.b_type) type = business.b_type;
        switch (type) {
            case "yoga":
                return yogaIconWhite;
            case "gym":
                return gymIconWhite;
            case "basketball":
                return ballIcon;
            case "dance":
                return danceIconWhite;
            case "school":
                return yogaIconWhite;
            case "ma":
                return maIconWhite;
            default:
                return yogaIconWhite;
        }
    },

    teacherIcon: function () {
        const business = this.business();
        let type = "yoga";
        if (business && business.b_type) type = business.b_type;
        switch (type) {
            case "yoga":
                return yogaPersonWhite;
            case "gym":
                return gymPersonWhite;
            case "basketball":
                return gymPersonWhite;
            case "dance":
                return genericPersonWhite;
            case "school":
                return genericPersonWhite;
            case "ma":
                return maPersonWhite;
            default:
                return genericPersonWhite;
        }
    },

    businessTypes: function () {
        commonStrings.setLanguage(localeHelpers.currentLocale());
        return [
            {value: 'yoga', label: commonStrings.business.yoga_studio},
            {value: 'gym', label: commonStrings.business.gym},
            {value: 'dance', label: commonStrings.business.dance_studio},
            {value: 'ma', label: commonStrings.business.ma},
            {value: 'pilates', label: commonStrings.business.pilates},
            {value: 'school', label: commonStrings.business.school},
            {value: 'team', label: commonStrings.business.team},
            {value: 'basketball', label: commonStrings.business.basketball},
        ];
    },

    teamMemberTypes: function () {
        commonStrings.setLanguage(localeHelpers.currentLocale());
        return [
            {value: 'a', label: commonStrings.business.admin},
            {value: 't', label: commonStrings.business.teacher},
            {value: 'tl', label: commonStrings.business.teacher_locale},
            {value: 'al', label: commonStrings.business.admin_locale},
        ];
    },

    isClientAccount(res) {
        if (res.user.user_type && res.current && res.current.user_type) {
            const user_type = res.user.user_type;
            const current_user_type = res.current.user_type;

            return user_type === "c" || current_user_type === "c"
        } else return false
    },

    isTeacherSession: function () {
        const user = this.subUser();
        return user && user.roles && user.roles.includes("t")
    },

    hasGroups: function () {
        return this.business().student_ranks && this.business().student_ranks.length > 0
    },


    businessHasConnectedStripeAccount() {
        const b = this.business()
        return b.s_pub_key && b.s_access_tkn && b.s_access_tkn.length > 0 && b.s_pub_key.length > 0
    },

    currentLocale() {
        return localStorage.locale_id || null;
    },

    checkLocale(data) {
        if (data.locales && data.locales.length > 0) {
            const cur = this.currentLocale()
            if (!data.locales.map((l) => {
                return l.id
            }).includes(parseInt(cur))) {
                this.saveCurrentLocale(data.locales[0].id)
            }
        }
    },


    saveCurrentLocale(id) {
        localStorage.locale_id = id;
        window.dispatchEvent(new Event("locale_set", {}));
    },
};

export default businessHelper;